// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TW2_5ANHtwkXl_ {
  display: flex;
  position: sticky;
  z-index: 3;
  top: var(--ds-space-0, 0);
  padding-bottom: var(--ds-space-100, 8px);
  background-color: var(--ds-surface-overlay, #ffffff);
}
.TW2_5ANHtwkXl_ .rpWYOQkS3LADB8 {
  position: absolute;
  top: var(--ds-space-100, 8px);
  left: var(--ds-space-100, 8px);
}
.TW2_5ANHtwkXl_ .XqnHq0Y8eGveEf {
  flex: auto;
}
.uxKsyNXEfg4Dsr {
  padding-top: var(--ds-space-100, 8px);
}
.jIYjDtCs0FDV01 {
  display: flex;
  box-sizing: border-box;
  height: 81px;
}
.jIYjDtCs0FDV01 > li {
  display: inline-block;
}
.qy7GidyQ606vto {
  box-sizing: content-box;
  width: calc(33.3% - 8px);
  height: 56px;
  padding: var(--ds-space-050, 4px);
}
.jIYjDtCs0FDV01 .qy7GidyQ606vto {
  box-sizing: border-box;
  flex: 1;
  width: auto;
  height: 81px;
}
.wT1m8rJYSjnpAi {
  display: flex;
  align-items: center;
  padding-top: var(--ds-space-050, 4px);
}
.A_oDDYB4REEVuM {
  flex-grow: 1;
  margin: var(--ds-space-0, 0);
  font-size: 14px;
  line-height: 18px;
}
.PMm2ec0e_Z8yIf {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  margin: var(--ds-space-0, 0);
  list-style: none;
}
.HjJYdD2ndeJboi {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 0;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
  border-radius: var(--ds-radius-small, 3px);
  background: none;
  background-color: var(--ds-background-neutral, #091e420f);
  background-position: center center;
  background-size: cover;
  box-shadow: none;
  color: var(--ds-background-inverse-subtle-pressed, #00000052);
  line-height: 0;
  cursor: pointer;
}
.HjJYdD2ndeJboi:focus,
.HjJYdD2ndeJboi:hover {
  background: none;
  background-color: var(--ds-surface, #ffffff);
  background-position: center center;
  background-size: cover;
  box-shadow: none;
}
.HjJYdD2ndeJboi:focus .B_4OEwUwa9rDF2,
.HjJYdD2ndeJboi:hover .B_4OEwUwa9rDF2 {
  opacity: 1;
  background: var(--ds-background-inverse-subtle-hovered, #0000003d);
}
.HjJYdD2ndeJboi:focus-visible {
  outline-offset: 2px;
}
.HjJYdD2ndeJboi.RYOmR6prPGKh4O::before,
.HjJYdD2ndeJboi:focus::before,
.HjJYdD2ndeJboi:hover::before {
  content: '';
  display: block;
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  border-radius: var(--ds-radius-small, 3px);
  background: rgba(0, 0, 0, 0.15);
}
.HjJYdD2ndeJboi:active::before {
  background: rgba(0, 0, 0, 0.25);
}
.HjJYdD2ndeJboi.RYOmR6prPGKh4O::before {
  background-color: var(--ds-background-inverse-subtle-pressed, #00000052);
}
.HjJYdD2ndeJboi.RYOmR6prPGKh4O:focus::before {
  background-color: var(--ds-background-inverse-subtle-pressed, #00000052);
}
.HjJYdD2ndeJboi.RYOmR6prPGKh4O:hover::before,
.HjJYdD2ndeJboi.RYOmR6prPGKh4O:active::before {
  background-color: var(--ds-background-inverse-subtle-pressed, #00000052);
}
.HjJYdD2ndeJboi > span {
  position: relative;
  z-index: 1;
}
.B_4OEwUwa9rDF2 {
  display: block;
  position: absolute;
  z-index: 2;
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  box-sizing: border-box;
  width: 100%;
  height: 20px;
  padding: var(--ds-space-025, 2px) var(--ds-space-050, 4px);
  overflow: hidden;
  opacity: 0;
  color: var(--ds-text-inverse, #ffffff);
  font-size: 12px;
  line-height: 16px;
  text-align: left;
  text-decoration: underline;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.B_4OEwUwa9rDF2:hover {
  background: var(--ds-background-inverse-subtle-pressed, #00000052);
  color: var(--ds-text-inverse, #ffffff);
}
.B_4OEwUwa9rDF2:focus {
  opacity: 1;
  background: var(--ds-background-inverse-subtle-pressed, #00000052);
}
.WqGQmp6O7mG5b8 {
  margin-bottom: var(--ds-space-0, 0);
  padding-bottom: var(--ds-space-0, 0);
}
.NcMyXU6PPGDzy3 {
  min-height: 500px;
}
/* display: none; won't work here, since we want to hide the text visually, but not from the a11y tree */
.gVZ6bUUGSwf_2C {
  position: fixed;
  top: -10px;
  left: -10px;
  max-width: 0;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}
`, ""]);
// Exports
export var searchWrapper = `TW2_5ANHtwkXl_`;
export var searchIcon = `rpWYOQkS3LADB8`;
export var searchInput = `XqnHq0Y8eGveEf`;
export var backgroundChooserColors = `uxKsyNXEfg4Dsr`;
export var itemRow = `jIYjDtCs0FDV01`;
export var backgroundGridItem = `qy7GidyQ606vto`;
export var backgroundChooserHeader = `wT1m8rJYSjnpAi`;
export var backgroundChooserHeading = `A_oDDYB4REEVuM`;
export var backgroundGrid = `PMm2ec0e_Z8yIf`;
export var backgroundGridTrigger = `HjJYdD2ndeJboi`;
export var photoAttributionLink = `B_4OEwUwa9rDF2`;
export var selectedPhoto = `RYOmR6prPGKh4O`;
export var bottomPadding = `WqGQmp6O7mG5b8`;
export var photosWrapper = `NcMyXU6PPGDzy3`;
export var hidden = `gVZ6bUUGSwf_2C`;
export default ___CSS_LOADER_EXPORT___;
